module.exports = __webpack_public_path__ + "img/mr.e99ebd77.png";